import { createContext, useContext, useState } from 'react'

const LanguageContext = createContext()

export function LanguageProvider({ children }) {

    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('language') || null
    })

    const changeLanguage = (newLanguage) => {
        setLanguage(newLanguage)
        localStorage.setItem('language', newLanguage)
    }

    const resetLanguage = () => {
        setLanguage(null)
        localStorage.removeItem('language')
    }

    return (
        <LanguageContext.Provider
            value={{
                language,
                changeLanguage,
                resetLanguage
            }}
        >
            {children}
        </LanguageContext.Provider>
    )
}

export function useLanguage() {
    return useContext(LanguageContext)
}